import { render, staticRenderFns } from "./direct_debit.vue?vue&type=template&id=6ac3fe20&scoped=true"
import script from "./direct_debit.vue?vue&type=script&lang=js"
export * from "./direct_debit.vue?vue&type=script&lang=js"
import style0 from "./direct_debit.vue?vue&type=style&index=0&id=6ac3fe20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3fe20",
  null
  
)

export default component.exports